import {useEffect} from 'react';
import useHomeMainExtra from './useHomeMainExtra';
import {getThemeOnBody} from '../../../common/function';
import useTypedSelector from '../../../common/hook/useTypedSelector';
import {sendExtra, sendPageView} from '../../../common/util/tracking';
import {getTimeTableSortingOption} from '../../timeTable/function';
import {getHomeActionName, TRACKING_HOME_SECTION} from '../tracking';
import {HomeTabPage} from '../type';

export default function useHomePageView(
  tabPage: HomeTabPage,
  secondTab: string
) {
  const [sortKeyByDayTab, genre] = useTypedSelector(state => [
    state.timeTable.sortKeyByDayTab,
    state.timeTable.genre,
  ]);
  useEffect(() => {
    tabPage !== HomeTabPage.MyPage &&
      sendHomePageView({
        tabPage,
        secondTab,
        customProps:
          tabPage === HomeTabPage.TimeTable &&
          secondTab !== 'new' &&
          secondTab !== 'complete'
            ? {
                list_type: 'triple',
                sorting_options: getTimeTableSortingOption(sortKeyByDayTab),
              }
            : undefined,
      });
  }, [tabPage, secondTab, sortKeyByDayTab, genre]);

  useHomeMainExtra();
}

function sendHomePageView({
  tabPage,
  secondTab,
  customProps,
}: {
  tabPage: HomeTabPage;
  secondTab: string;
  customProps?: object;
}) {
  const section = TRACKING_HOME_SECTION[tabPage];
  const actionName = getHomeActionName(tabPage, secondTab);

  if (actionName) {
    sendPageView({
      section,
      page: `${section}_${actionName.replace('top_', '')}`,
      actionName,
      isSendExtra: tabPage === HomeTabPage.Main && secondTab !== 'hot',
      customProps: {
        display_theme: getThemeOnBody(),
        ...customProps,
      },
    });
  }
}

export function sendHomeExtra({
  tabPage,
  secondTab,
  customProps,
}: {
  tabPage: HomeTabPage;
  secondTab: string;
  customProps: {};
}) {
  const section = TRACKING_HOME_SECTION[tabPage];
  const actionName = getHomeActionName(tabPage, secondTab);
  if (actionName) {
    sendExtra({
      section,
      page: `${section}_${actionName}`,
      actionName,
      customProps: {
        ...customProps,
        display_theme: getThemeOnBody(),
      },
    });
  }
}
